import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-session-expired',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.css']
})
export class SessionExpiredComponent implements OnInit, OnDestroy {
  visible: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.tokenExpired$.subscribe(
      (isExpired: boolean) => {
        this.visible = isExpired;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reconnect(): void {
    this.authService.clearTokenExpired();
    this.visible = false;
    this.router.navigate(['/login']);
  }

  cancel(): void {
    this.visible = false;
    // Optionnel : rediriger vers une page d'accueil ou garder sur la page actuelle
  }
}
